import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle } from "vue";
const _hoisted_1 = ["aria-labelledby"];
const _hoisted_2 = {
    key: 0,
    id: "app-dialog-title",
    class: "app-dialog-title",
    "data-test": "app-dialog-title"
};
const _hoisted_3 = {
    id: "app-dialog-message",
    class: "app-dialog-message",
    "data-test": "app-dialog-message"
};
const _hoisted_4 = { class: "dialog-menu app-dialog-buttons" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("dialog", {
        ref: "dialog",
        class: "app-dialog",
        style: _normalizeStyle({ fontSize: _ctx.fontSize }),
        role: "alertdialog",
        "aria-modal": "true",
        "aria-labelledby": _ctx.title !== '' ? 'app-dialog-title' : undefined,
        "aria-describedby": "app-dialog-message",
        "data-test": "app-dialog",
        onCancel: _cache[2] || (_cache[2] = _withModifiers(($event) => (_ctx.answer(false)), ["prevent"])),
        onKeydown: _cache[3] || (_cache[3] =
            //@ts-ignore
            (...args) => (_ctx.onKeydown && _ctx.onKeydown(...args)))
    }, [
        _createElementVNode("form", {
            method: "dialog",
            onSubmit: _cache[1] || (_cache[1] = _withModifiers(($event) => (_ctx.answer(true)), ["prevent"]))
        }, [
            (_ctx.title !== '')
                ? (_openBlock(), _createElementBlock("p", _hoisted_2, _toDisplayString(_ctx.title), 1))
                : _createCommentVNode("", true),
            _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.message), 1),
            _createElementVNode("menu", _hoisted_4, [
                _createElementVNode("button", {
                    ref: "ok",
                    type: "submit",
                    class: _normalizeClass(["btn btn-lg", _ctx.danger ? 'btn-error' : 'btn-primary']),
                    "data-test": "app-dialog-ok"
                }, _toDisplayString(_ctx.okLabel), 3),
                (_ctx.isConfirm)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        ref: "cancel",
                        type: "button",
                        class: "btn btn-lg",
                        "data-test": "app-dialog-cancel",
                        onClick: _cache[0] || (_cache[0] = ($event) => (_ctx.answer(false)))
                    }, _toDisplayString(_ctx.cancelLabel), 513))
                    : _createCommentVNode("", true)
            ])
        ], 32)
    ], 44, _hoisted_1));
}
